/**
 * Chip is used to display a string as a Chip with an optional close button.
 *  @param {string} text - The text to render in the Chip. It should already be humanized.
 *  @param {string} style - The text of the style indicating classes to be used, currently supporting teal and blue.
 *  @param {string} icon - Optional, fortawesome icon name for a right-justified icon on the Chip. If not provided, no icon is shown.
 *  @param {string} iconSize - Optional, size of icon, ex. "10em", "10px". Default is "0.6em"
 *  @param {function} onClick - Optional, function that will be called when a user clicks on the Chip.
 */
import ApplicationComponent from "legacy/ApplicationComponent"
import PropTypes from "prop-types"
import React from "react"

class Chip extends ApplicationComponent {
  style() {
    const styles = {
      teal: {
        buttonClass: "bg-teal-100 p-1",
        iconClass:
          "text-teal-800 group-hover:text-teal-800 group-hover:bg-teal-300",
        textClass: "text-teal-800 text-xs",
      },
      blue: {
        buttonClass: "bg-blue-200 rounded-2xl py-1 px-2",
        iconClass:
          "text-blue-600 group-hover:text-blue-700 group-hover:bg-blue-300",
        textClass: "text-blue-600",
      },
    }
    return styles[this.props.style]
  }

  render() {
    return (
      <button
        type={"button"}
        onClick={this.props.onClick}
        className={`group flex flex-row ${
          this.style().buttonClass
        } items-center justify-between ${
          this.props.onClick && "cursor-pointer"
        }`}
      >
        <div
          className={`truncate whitespace-nowrap font-semibold ${
            this.style().textClass
          } px-1`}
        >
          {this.props.text}
        </div>
        {this.props.icon && (
          <div className={"flex h-4 w-4 items-center justify-center"}>
            <i
              className={`${this.style().iconClass} rounded-full p-1 ${
                this.props.icon
              }`}
              style={{ fontSize: this.props.iconSize || "0.6em" }}
            />
          </div>
        )}
      </button>
    )
  }
}

Chip.propTypes = {
  text: PropTypes.string.isRequired,
  style: PropTypes.oneOf(["teal", "blue"]).isRequired,
  icon: PropTypes.string,
  iconSize: PropTypes.string,
  onClick: PropTypes.func,
}

export default Chip
